import React from 'react'
import { verifyPayment } from '../app/apis';
import Navbar from './Navbar';
import {  toast } from 'react-toastify'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import LoadingBar from 'react-top-loading-bar'
import { VscLoading } from "react-icons/vsc";
import {resetForm} from './../features/form/formSlice'
import {usePostNewFormMutation} from './../features/form/formApiSlice'
import { useDispatch } from 'react-redux';

const Payment = () => {

    /*
    <QueryDict: {'order_id': ['694a4a7be189787f'], 'status': ['NEW'], 'sdk_status': ['backpressed'], 'status_id': ['10']}>
    <QueryDict: {'status': ['CHARGED'], 'signature_algorithm': ['HMAC-SHA256'], 'status_id': ['21'], 'signature': ['yeaeVQTh4wgbtY2frPAA8A6A8apMJ27m69Yx42kgt5o='], 'order_id': ['694a4a7be189787f']}>
    */

    let navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const [progress, setProgress] = useState(0)
    const [postNewForm, {isLoading: loadingNew}] = usePostNewFormMutation()
    const [load, setLoad] = useState(false)
    const isInitialMount = useRef(true);
    const dispatch = useDispatch()
    
    // Read status, status_id and order_id query parameters
    const status = searchParams.get('status')
    const statusId = searchParams.get('status_id')
    const orderID = searchParams.get('order_id') || searchParams.get('orderID')
    
    // Check if status is 21 (either from status or status_id parameter)
    const isSuccess = status === '21' || statusId === '21'

    useEffect(() => {
        if (isInitialMount.current) {
            // close window
            // submit_form()

            // update_paid_status_api_call()
            isInitialMount.current = false;
         } else {
             // Your useEffect code here to be run on update
         }
      },[]
    )

    // let submit_form = async () => {
    //     setLoad(true)
    //     setProgress(30)
    //     let tempForm = JSON.parse(localStorage.getItem("tempForm"))
    //     try {
    //         let res = await verifyPayment({"order_id": tempForm["RazorpayPaymentID"]})
    //         res = await res.json
    //         console.log(res)
    //         if (res["val"] && res["data"]) {
    //             setProgress(50)
    //             res = await postNewForm(tempForm).unwrap()
    //             dispatch(resetForm())
    //             setProgress(100)
    //             setLoad(false)
    //             toast.success("Payment successful and form submitted!")
    //             localStorage.removeItem("tempForm")
    //             return
    //         } else {
    //             toast.error("Payment verification failed. Please refill the form and try again.")
    //             setLoad(false)
    //             setProgress(100)
    //             try{
    //                 await refund_money()
    //             }catch(e){
    //                 console.log(e)
    //                 toast.error("Some error occurred while processing refund. Please contact us.")
    //             }
    //             localStorage.removeItem("tempForm")
    //             return
    //         }
    //     } catch (error) {
    //         toast.error("Some error occurred while verifying payment. Please try again later.")
    //         setLoad(false)
    //         setProgress(100)
    //         console.log(error)
    //         try{
    //             await refund_money()
    //         }catch(e){
    //             console.log(e)
    //             toast.error("Some error occurred while processing refund. Please contact us.")
    //         }
    //         localStorage.removeItem("tempForm")
    //         return
    //     }
    // }

    let refund_money = async () => {
        // TODO REFUND API CALL
    }

    let payData = [
        {
            "d": "Membership Fee",
            "a": "Rs. 500"
        },
        {
            "d": "GST 18%",
            "a": "Rs. 90"
        },
        {
            "d": "Total",
            "a": "Rs. 590"
        }
    ]

    return (
        <div className='w-full'>
            <Navbar/>
            <LoadingBar color='#f11946' progress={progress} />
            <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2 mt-10'>
                Payment Breakdown
            </h1>
            <table class="w-full mt-10 justify-center items-center flex flex-col">
                
                <tbody>
                    {payData.map((data, key) => (
                        <tr key={key} class="border-b">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                {data.d}
                            </td>
                            <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                {data.a}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {orderID && (
                <div className='mt-6 text-center'>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2'>
                        Order ID: {orderID}
                    </h1>
                </div>
            )}
            {load ? (
                <div className='flex flex-col'>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-2xl heading text-purple-600 mb-2 mt-20'>
                        Processing your payment ...
                    </h1>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2 mt-5'>
                        Please wait for a moment
                    </h1>
                </div>
            ): isSuccess ? (
                <div>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2 mt-20'>
                        Payment Received!
                    </h1>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-purple-600 mb-2 mt-10'>
                        Welcome to Matunga Boarding!
                    </h1>
                </div>
            ) : (
                <div>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-red-600 mb-2 mt-20'>
                        Payment Failed
                    </h1>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-red-600 mb-2 mt-10'>
                        You might have to wait for 1 hour before trying again.
                    </h1>
                    <h1 className='font-semibold text-lg sm:text-xl py-2 text-center md:text-4xl heading text-red-600 mb-2 mt-10'>
                        Please try again or contact support
                    </h1>
                </div>
            )}
        </div>
    )
}

export default Payment